/* Made by Minga mega menu: desktop photo swap + mobile accordions */
(function () {
  if (window.mingaMegaMenuLoaded) return;
  window.mingaMegaMenuLoaded = true;

  var preloaded = {};
  function preload(panel) {
    if (panel.dataset.mmPreloaded) return;
    panel.dataset.mmPreloaded = '1';
    panel.querySelectorAll('[data-mm-img]').forEach(function (el) {
      var src = el.getAttribute('data-mm-img');
      if (src && !preloaded[src]) {
        preloaded[src] = true;
        var i = new Image();
        i.src = src;
      }
    });
  }

  function show(panel, src, title, meta, activeEl) {
    var photo = panel.querySelector('.minga-mega__photo');
    if (!photo) return;
    var img = photo.querySelector('.minga-mega__img');
    var capTitle = photo.querySelector('.minga-mega__cap-title');
    var capMeta = photo.querySelector('.minga-mega__cap-meta');
    panel.querySelectorAll('.is-active').forEach(function (a) { a.classList.remove('is-active'); });
    if (activeEl) activeEl.classList.add('is-active');
    if (!src) src = photo.dataset.mmDefaultImg;
    capTitle.textContent = title || '';
    capMeta.textContent = meta || '';
    if (!src || img.getAttribute('src') === src) {
      if (src) img.hidden = false;
      return;
    }
    img.hidden = false;
    img.classList.add('is-fading');
    var swap = function () {
      img.src = src;
      img.classList.remove('is-fading');
    };
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) swap();
    else setTimeout(swap, 120);
  }

  function reset(panel) {
    var photo = panel.querySelector('.minga-mega__photo');
    if (!photo) return;
    show(panel, photo.dataset.mmDefaultImg, photo.dataset.mmDefaultTitle, '', null);
  }

  function onEnter(evt) {
    var target = evt.target.closest ? evt.target.closest('[data-mm-title]') : null;
    var panel = evt.target.closest ? evt.target.closest('.minga-mega') : null;
    if (!panel) return;
    preload(panel);
    if (!target) return;
    show(panel, target.getAttribute('data-mm-img'), target.getAttribute('data-mm-title'), target.getAttribute('data-mm-cap'), target);
  }

  document.addEventListener('mouseover', onEnter);
  document.addEventListener('focusin', onEnter);
  document.addEventListener('mouseout', function (evt) {
    var panel = evt.target.closest ? evt.target.closest('.minga-mega') : null;
    if (panel && !panel.contains(evt.relatedTarget)) reset(panel);
  });

  // Mobile accordions: one open at a time
  document.addEventListener('click', function (evt) {
    var toggle = evt.target.closest ? evt.target.closest('.minga-mob__toggle') : null;
    if (!toggle) return;
    evt.preventDefault();
    var list = toggle.closest('.minga-mob');
    var wasOpen = toggle.getAttribute('aria-expanded') === 'true';
    list.querySelectorAll('.minga-mob__toggle').forEach(function (t) {
      t.setAttribute('aria-expanded', 'false');
      if (t.nextElementSibling) t.nextElementSibling.hidden = true;
    });
    if (!wasOpen) {
      toggle.setAttribute('aria-expanded', 'true');
      if (toggle.nextElementSibling) toggle.nextElementSibling.hidden = false;
    }
  });
})();
